import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { colors } from "../../utils/const";
import { useI18n } from "@/i18n/I18nProvider";
import dynamic from "next/dynamic";
import PageHead from "@/components/PageHead";
import Image from "next/image";

const Benifits = dynamic(() => import("@/components/mini-components/Benifits"), {
  ssr: false,
  loading: () => (
    <Box className="horizontal-safe-padding" sx={{ mt: 4 }}>
      <Box sx={{ height: { xs: 260, md: 340 }, width: "100%" }} />
    </Box>
  ),
});

const SOLUTION_SRC =
  "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/solution.webp";

export default function Referral_Program() {
  const { t, locale } = useI18n();

  return (
    <>
      <PageHead
        title={t.pages_main_tags.referralProgram.title}
        description={t.pages_main_tags.referralProgram.meta_desc}
      />

      <Box
        className="horizontal-safe-padding vertical-safe-padding"
        sx={{ position: "relative" }}
      >

        <Box>
          <Box
            sx={{
              display: { lg: "flex" },
              justifyContent: "space-between",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Box sx={{ textAlign: "center", width: { lg: "420px" } }}>
              <Box
                sx={{
                  position: "relative",
                  width: { xs: "250px", sm: "350px", md: "420px" },
                  height: { xs: "300px", sm: "400px", md: "500px" },
                  mb: { xs: 2, lg: 0 },
                  mx: "auto",
                }}
              >
                <Image
                  alt="solution"
                  src={SOLUTION_SRC}
                  fill
                  sizes="(max-width: 600px) 250px, (max-width: 900px) 350px, 420px"
                  style={{ objectFit: "contain" }}
                  // If this image is visible above-the-fold, prefer priority to improve LCP
                  priority
                />
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                mr: locale === "ar" ? { lg: 20 } : { lg: 0 },
                ml: locale === "en" ? { lg: 20 } : { lg: 0 },
                minWidth: 0,
                flex: "1 1 auto",
              }}
            >
              <Typography
                variant="h2"
                component="h1"
                sx={{
                  color: colors.blue,
                  mb: 0,
                  fontWeight: "bold",
                  fontSize: "2rem",
                }}
              >
                {t.referral_program.title}
              </Typography>

              <Typography sx={{ mb: 3 }}>
                {t.referral_program.sub_title}
              </Typography>

              <Typography
                variant="h6"
                component="h2"
                sx={{ color: colors.blue, fontWeight: "bold" }}
              >
                {t.referral_program.conditions.title}
              </Typography>

              {t.referral_program.conditions.conditions_list.map(
                (condition, index) => (
                  <Box
                    key={`${index}-${condition}`}
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: { xs: "start", lg: "center" },
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        bgcolor: colors.orange,
                        borderRadius: "50%",
                        width: { xs: "30px", md: "32px" },
                        height: { xs: "30px", md: "32px" },
                        fontSize: { xs: "16px", sm: "22px" },
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "white",
                        flex: "0 0 auto",
                      }}
                    >
                      {index + 1}
                    </Box>

                    <Typography sx={{ fontWeight: "300", color: colors.blue }}>
                      {condition}
                    </Typography>
                  </Box>
                )
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      <Benifits
        title={t.referral_program.program_benefits}
        list={t.referral_program.benefites_list}
      />
    </>
  );
}
